// extracted by mini-css-extract-plugin
export default {"full-width":"O44A7N","fullWidth":"Arkh2d","root":"LHp1CL","initialized":"v30l64","testNodeWrapper":"J4S8Co","testText":"j3OubE"};